import React from 'react'

function ShowAppDetails() {
  return (
    <div>ShowAppDetails</div>
  )
}

export default ShowAppDetails